export default {
  CYBERPAY: {
    INTEGRATION_KEY: "d7c94c2c63734138bd1f2acfe8883fbc",
    NARRATION: "PREMIUM PENSION TEST TRANSACTION",
    CREDENTIALS:
      "n6gmOSAVsUJgSR5rXyvqKBCfPuF8D7D7aZnO1w2TsKUGhZuHISDJgLHK3cWGUB3FW7nCWKkb0SfZhyxWc0wX/NU/BKkptDERDclzWSUyzUg=",
    PFA_CODE: "022",
  },
};
